import { useCallback } from 'react';

import type { InvestorFirmRelationshipCreateInput } from '../../../../../../../../graphql';
import {
  useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation,
  useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation,
} from '../graphql/__generated__';

export function useAddSalesCoverageCreateRelationship(tenantId?: string) {
  const [createRelationshipsAsCustomer] =
    useAddSalesCoverage_CreateUnderwriterEmployeeRelationshipsMutation();
  const [createRelationshipsAsAdmin] =
    useAddSalesCoverage_AdminCreateUnderwriterEmployeeRelationshipsMutation();

  return useCallback(
    async (input: InvestorFirmRelationshipCreateInput[]) => {
      if (tenantId) {
        return await createRelationshipsAsAdmin({
          variables: {
            input: {
              tenantId,
              input,
            },
          },
        });
      } else {
        return await createRelationshipsAsCustomer({
          variables: {
            input,
          },
        });
      }
    },
    [tenantId, createRelationshipsAsAdmin, createRelationshipsAsCustomer]
  );
}
